import {getBreadCrumbList, getHomeRoute} from "../../libs/utils";
import router from '../../router/router';

export default {
  state: {
    authorization: '',
    breadCrumbList: localStorage.getItem('breadCrumbList') ? JSON.parse(localStorage.getItem('breadCrumbList')) : [],
    // homeRoute: getHomeRoute(router),
    // userLang: localStorage.getItem('lang') ? localStorage.getItem('lang') : 'zh-CN',
    multiTabList: [], // 多标签页面列表
    multiTabNameList: [], // 多标签页面name列表
    tabActiveKey: 0, // 标签页当前位置
    collapsed: false, // sidermenu 缩小
  },
  getters: {
    authorization(state, getters, rootState) {
      return rootState.app.authorization;
    },
    // userLang(state, getters, rootState) {
    //   return rootState.app.userLang;
    // },
    breadCrumbList(state, getters, rootState) {
      return rootState.app.breadCrumbList;
    },
    multiTabList(state, getters, rootState) {
      return rootState.app.multiTabList;
    },
    multiTabNameList(state, getters, rootState) {
      return rootState.app.multiTabNameList;
    },
    collapsed(state, getters, rootState) {
      return rootState.app.collapsed;
    },
    tabActiveKey(state, getters, rootState) {
      return rootState.app.tabActiveKey;
    },
  },
  mutations: {
    REMOVETAB(state, idx) {
      state.multiTabNameList.splice(idx, 1);
    },
    ADDTAB(state, {pageNames, idx}) {
      state.multiTabNameList.splice(idx, 0, pageNames);
    },
    SETCOLLAPSED(state, collapsed) {
      state.collapsed = collapsed;
    },
    SETAUTHORIZATION(state, authorization) {
      state.authorization = authorization;
      localStorage.setItem("authorization", authorization);
    },
    // SETUSERLANG(state, userLang) {
    //   state.userLang = userLang;
    //   localStorage.setItem("lang", userLang);
    // },
    SETBREADCRUMB(state, {list, route}) {
      let breadCrumbList = getBreadCrumbList(list, route.path);
      state.breadCrumbList = breadCrumbList;
      localStorage.setItem('breadCrumbList', JSON.stringify(breadCrumbList));
    },
    ADDONETABPAGE(state, {page, $router, idx}) {
      let hasPage = false;
      console.log(page);
      for(let i = 0; i < state.multiTabList.length; i++) {
        if(state.multiTabList[i].path === page.path) {
          hasPage = true;
          state.tabActiveKey = i; // tab显示在已有标签
          break;
        }
      }
      if(!hasPage) { // 不在列表则新增
        state.multiTabList.push(page);
        state.multiTabNameList.push(page.name);
        state.tabActiveKey = state.multiTabList.length - 1; // tab显示在新加标签
      }
    },
    DELETEONETABPAGE(state, {idx, $router}) {
      let oldPagePath = state.multiTabList[state.tabActiveKey].path;
      let pages = state.multiTabList.splice(idx, 1);
      state.multiTabNameList = state.multiTabNameList.filter(item => {
        return item != pages[0].name;
      })
      if($router) {
        let index = 0;
        if(state.tabActiveKey > idx){
          index = state.tabActiveKey - 1;
        } else if(state.tabActiveKey == idx){
          if(idx > 0){
            index = idx - 1;
          } else {
            index = 0;
          }
        } else {
          index = state.tabActiveKey;
        }
        let page = state.multiTabList[index];
        state.tabActiveKey = index;
        if(oldPagePath != page.path) {
          // 做跳转
          $router.push({
            path: page.path
          }).catch(err => {
            console.log(err);
          })
        }
      }
    },
    CLEARTABPAGE(state) {
      state.multiTabList = [];
    },
    // 点击tab 的 idx
    CHANGETABINDEX(state, {idx, $router}) {
      state.tabActiveKey = idx;
      console.log($router);
      if($router) {
        let page = state.multiTabList[idx];
        // 做跳转
        $router.push({
          path: page.path
        }).catch(err => {
          console.log(err);
        })
      }
    }
  },
  actions: {
    addTab(context, {pageNames, idx}){
      context.commit('ADDTAB',  {pageNames, idx});
    },
    removeTab(context, idx){
      context.commit('REMOVETAB', idx);
    },
    refleshPage(context, {pageName, $router}) {
      context.commit('REFLESHPAGE',  {pageName, $router});
    },
    changeTabIndex(context, {idx, $router}) {
      context.commit('CHANGETABINDEX', {idx, $router});
    },
    setCollapsed(context, collapsed) {
      context.commit('SETCOLLAPSED', collapsed);
    },
    // setUserLanguage(context, {userLang}) {
    //   // 切换语言
    //   context.commit('SETUSERLANG', userLang);
    // },
    // 添加一个标签页
    addOneTabPage(context, {page, $router}) {
      context.commit('ADDONETABPAGE',  {page, $router});
    },
    // 关闭一个标签页
    closeOneTabPage(context, {idx, $router}) {
      context.commit('DELETEONETABPAGE', {idx, $router});
    },
    // 关闭所有标签页
    closeAllTabPage(context, $router) {
      context.commit('CLEARTABPAGE', $router);
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/module/app.js